import { render } from "./YouTubePlayerFrame.vue?vue&type=template&id=3c76f8f8&scoped=true"
import script from "./YouTubePlayerFrame.vue?vue&type=script&lang=js"
export * from "./YouTubePlayerFrame.vue?vue&type=script&lang=js"

import "./YouTubePlayerFrame.vue?vue&type=style&index=0&id=3c76f8f8&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c76f8f8"]])

export default __exports__